import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "../actions";
import ApplicationForm from "../components/applicationForm/applicationForm";
import {
  AUTHORIZATION_CODE,
  CLIENT_CREDENTIALS,
  DEVELOPMENT,
} from "../constants/application";
import Breadcrumb from "../components/breadcrumb/breadcrumb";
import withTracker from "./withtracker";
import AuthorizationHOC from "./AuthorizationHOC";
import { REGISTERED_USERS } from "../constants/userGroups";
import withBreadCrumb from "./withBreadcrumb";
import EditApplicationPermissionDeny from "../components/editApplicationPermissionDeny/editApplicationPermissionDeny";
import { parseApplicationFromState } from "../constants/parse/application";
import { getRouteUrl } from "../routers";
import { ROUTE_APPLICATION_VIEW } from "../routers/content/application";
import SectionStart from "../components/sectionStart/sectionStart";
import {
  Sidebar,
  SidebarHeader,
  SideBar,
  SidebarRight,
  SidebarLeft,
} from "../components/layouts/layout1";
import Title from "../components/title/title";
import Heading from "../components/heading/heading";
import BracketButton from "../components/bracketButton/bracketButton";
import { ROUTE_ORGANIZATION_VIEW_SINGLE } from "../routers/content/organization";
import queryString from "query-string";
import { parseOrganization } from "../constants/parse/organization";

const parseTags = (tags) => {
  if (!tags) return [];
  if (Array.isArray(tags)) return tags;
  if (typeof tags === "object") return Object.values(tags);
  return [];
};

function ApplicationEditHOC(props) {
  const {
    breadcrumb,
    loading,
    errorMessage,
    applicationForm,
    updateOAuthTag,
    updatePostLogoutTag,
    editApplication,
    prepareEditApplication,
    fetchApplication,
  } = props;

  const title = applicationForm?.form?.title;
  const uuid = applicationForm?.form?.applicationUuid;
  const applicationStatus = applicationForm?.form?.applicationStatus;

  const { applicationId } = props.match.params;
  const { application } = props;

  const { organizations, location } = props;
  const { organization } = queryString.parse(location.search);

  const appExistsInState =
    application &&
    application.applicationsById &&
    application.applicationsById[applicationId];

  useEffect(() => {
    if (organization) {
      fetchApplication({ applicationId, organizationId: organization });
    }
  }, [organization]);

  useEffect(() => {
    if (appExistsInState) {
      const parsedApp = parseApplicationFromState(application, applicationId);
      if (parsedApp && parsedApp.uuid) {
        prepareEditApplication({
          application: parsedApp,
        });
      }
    }
  }, [appExistsInState]);

  useEffect(() => {
    if (!organizations || !organizations[organization]) {
      props.fetchOrganizations({
        uuid: organization,
      });
    }
  }, [organization]);

  const organizationData = parseOrganization(
    props.organizations && props.organizations[organization]
  );

  // Prepare initial values for Formik
  const initialValues = {
    title: applicationForm?.form?.title || "",
    description: applicationForm?.form?.description || "",
    authorizationCodeAllowed:
      applicationForm?.form?.authorizationCodeAllowed ?? false,
    clientCredentialsAllowed:
      applicationForm?.form?.clientCredentialsAllowed ?? false,
    applicationUuid: applicationForm?.form?.applicationUuid || "",
    subscriptionIds: applicationForm?.form?.subscriptionIds || [],
  };

  return (
    <div>
      {title && organizationData && (
        <Breadcrumb
          {...breadcrumb}
          params={{
            app: {
              name: title,
              href: uuid
                ? getRouteUrl(
                    ROUTE_APPLICATION_VIEW,
                    { applicationId: uuid },
                    { organization: organization }
                  )
                : null,
            },
            org: {
              href: getRouteUrl(ROUTE_ORGANIZATION_VIEW_SINGLE, {
                organizationId: organization,
              }),
              name: organizationData.title,
            },
          }}
        />
      )}
      <SectionStart>
        <SideBar>
          <SidebarLeft>
            {" "}
            <SidebarHeader>
              <Title type="section">
                <Heading level="1" className="display-effect">
                  Edit application
                </Heading>
              </Title>
              <BracketButton
                caretEnable
                className="movingBrackets left"
                title={"BACK TO OVERVIEW"}
                url={getRouteUrl(ROUTE_ORGANIZATION_VIEW_SINGLE, {
                  organizationId: organization,
                })}
              />
            </SidebarHeader>
          </SidebarLeft>
          <SidebarRight>
            <ApplicationForm
              editApplication={(values) =>
                editApplication({ ...values, organizationId: organization })
              }
              loading={loading}
              errorMessage={errorMessage}
              oAuthTagsValue={parseTags(applicationForm?.oAuthRedirectUri)}
              oAuthTagsUpdate={updateOAuthTag}
              postLogoutTagsValue={parseTags(
                applicationForm?.postLogoutRedirectUri
              )}
              postLogoutUpdate={updatePostLogoutTag}
              editing
              applicationStatus={applicationStatus}
              initialValues={initialValues}
            />
          </SidebarRight>
        </SideBar>
      </SectionStart>
    </div>
  );
}

const mapStateToProps = (state) => ({
  organizations: state.organizationReducer?.byId,
  loading: state.application?.loading,
  errorMessage: state.application?.errorMessage,
  application: state.application,
  applicationForm: state.applicationForm,
});

const createGrantTypes = (auth, credentials) => {
  const grantTypes = [];
  if (auth) grantTypes.push(AUTHORIZATION_CODE);
  if (credentials) grantTypes.push(CLIENT_CREDENTIALS);
  return grantTypes;
};

const mapDispatchToProps = (dispatch) => ({
  editApplication: (payload) => {
    dispatch(
      actions.editApplication({
        applicationUuid: payload?.applicationUuid,
        title: payload?.title,
        description: payload?.description,
        allowedGrantTypes: createGrantTypes(
          payload?.authorizationCodeAllowed,
          payload?.clientCredentialsAllowed
        ),
        oAuthRedirectUri: payload?.oAuthRedirectUri,
        postLogoutRedirectUri: payload?.postLogoutRedirectUri,
        organizationId: payload?.organizationId,
        subscriptionIds: Array.isArray(payload?.subscriptionIds)
          ? payload.subscriptionIds
          : Object.values(payload?.subscriptionIds || {}),
      })
    );
  },
  fetchOrganizations: (payload) => {
    dispatch(actions.fetchOrganizations(payload));
  },
  fetchApplication: (payload) => {
    dispatch(actions.fetchApplication(payload));
  },
  updateOAuthTag: (payload) => {
    dispatch(actions.updateOAuthTag(payload));
  },
  updatePostLogoutTag: (payload) => {
    dispatch(actions.updatePostLogoutTag(payload));
  },
  prepareEditApplication: (payload) => {
    dispatch(actions.prepareEditApplication(payload));
  },
  clearFormState: () => {
    dispatch(actions.clearStateAfterCreatingApplication());
  },
});

// export default connect(mapStateToProps, mapDispatchToProps)(ApplicationEditHOC);
export default withTracker(
  AuthorizationHOC(REGISTERED_USERS)(
    withBreadCrumb(
      connect(mapStateToProps, mapDispatchToProps)(ApplicationEditHOC),
      {
        name: "Edit",
        parents: ["Organizations", "{org}", "{app}"],
      }
    )
  )
);
